import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { contactInfo, utilityLinks } from '../../data/site';
export function UtilityBar() {
  return <div className="bg-brand-navy text-white" data-id="element-45" data-mp="1woqiz7r3yxn5">
      <div className="px-fluid flex flex-col gap-1.5 py-2 text-[clamp(0.72rem,0.68rem+0.15vw,0.95rem)] sm:flex-row sm:items-center sm:justify-between" data-id="element-46" data-mp="2aihirof1f35o">
        <ul className="flex flex-wrap items-center gap-x-5 gap-y-1" data-id="element-47" data-mp="25lhbja6gbucz">
          <li data-id="element-48" data-mp="1hu2h03kx2hca">
            <a href={contactInfo.phoneHref} className="inline-flex items-center gap-1.5 font-medium hover:text-brand-accent" data-id="element-49" data-mp="1htu0m1pl4twc">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-50" data-mp="1rrqdoz231yx3" />
              {contactInfo.phoneDisplay}
            </a>
          </li>
          <li data-id="element-51" data-mp="1mrlsivq8cg0j">
            <a href={contactInfo.emailHref} className="inline-flex items-center gap-1.5 font-medium hover:text-brand-accent" data-id="element-52" data-mp="1mr2cxlo1y3po">
              <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="338q2vlt4vxmw" />
              {contactInfo.email}
            </a>
          </li>
        </ul>
        <nav aria-label="Utility" data-id="element-54" data-mp="1yo41zkjknpna">
          <ul className="flex flex-wrap items-center gap-x-1 gap-y-1 text-white/90" data-id="element-55" data-mp="1yn2svlm49d87">
            {utilityLinks.map((link, i) => <li key={link.href} className="flex items-center" data-id="element-56" data-mp="28lighelxq4cy" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" className="mx-2 text-white/40" data-id="element-57" data-mp="2dklbs7c44w7q">
                    ·
                  </span>}
                <a href={link.href} className="hover:text-white hover:underline underline-offset-4" data-id="element-58" data-mp="1fxw3jfqthndf">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </div>;
}